import React, { useEffect, useState } from "react";
import "../App.css";
import Nav from "./Navigation.js";
import { getTokenInternal } from "./useToken";
import { useNavigate } from "react-router-dom";


export default function MyProfile() {
  const [myself, setMyself] = useState({});
  const [token, setToken] = useState();
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();


  useEffect(() => {
    const fetchToken = async () => {
      try {
        const fetchedToken = await getTokenInternal();
        setToken(fetchedToken);
      } catch (error) {
        console.error("Error fetching token:", error);
      }
    };
    fetchToken();
  }, []);

  const fetchData = async () => {
    if (token) {
      const url = `${process.env.REACT_APP_API_HOST}/api/accounts/${token.account.username}`;
      const response = await fetch(url);
      const completeList = await response.json();
      setMyself(completeList);
      setVisible(completeList.visible || false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [token]);

const handleToggle = () => {
  // Update the visible status
  setVisible(!visible);

  fetch(
    `${process.env.REACT_APP_API_HOST}/api/accounts/${token.account.username}`,
    {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token?.access_token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ visible: !visible }),
    }
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error("Error updating account.");
      }
      return response.json();
    })
    .then((data) => {
    })
    .catch((error) => {
      console.error("Error updating account:", error);
    });
};

const handleDeleteAccount = async () => {
  try {
    const url = `${process.env.REACT_APP_API_HOST}/api/accounts/${token?.account.username}`;
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token.access_token}`,
      },
    });

    if (response.ok) {
      navigate("/welcome");
    } else {
      console.error("Failed to delete account:", response.statusText);
    }
  } catch (error) {
    console.error("Error deleting account:", error);
  }
};



  return (
    <div>
      <Nav />
      <div className="text-white text-center">
        <div>
          <h1 className="text-3xl font-bold mb-4">My Profile Settings</h1>
          <div>
            <span className="mr-2">Username:</span>
            <span>{myself.username}</span>
          </div>
          <div>
            <span className="mr-2">Discord Name:</span>
            <span>{myself.discord_name}</span>
          </div>
          <div className="mt-4">
            <span className="mr-2">Discord Name Visible To Friends:</span>
            <label className="switch">
              <input
                type="checkbox"
                checked={visible}
                onChange={handleToggle}
              />
              <span className="slider"></span>
            </label>
          </div>
          <div className="mt-10">
            <button
              className="mr-2 p-1 border rounded"
              onClick={() => {
                navigate(`/edit-my-account/${myself.id}`, {
                  state: { myself },
                });
              }}
            >
              Change My Account Name or Password
            </button>
          </div>
          <div className="mt-10">
            <button
              type="button"
              className="ml-2 bg-red-500 border-solid border-2 border-white text-white px-1 py-0 rounded"
              onClick={() => handleDeleteAccount()}
            >
                Delete My Account
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
